import { useEnvironmentVariables } from "components/Settings/SettingsEnvVariables/useEnvironmentVariables";
import { useProjectSettingsContext } from "components/Settings/SettingsProvider";
import { useEditor } from "features/editor/Feature";
import { useAddAlertNotification } from "features/notifications/hooks";
import { useEffect } from "react";

import { useScopedPersistedState } from "hooks/usePersistedState";

export const MissingEnvVarNotification: React.FC = () => {
  const { id, allowedCapabilities } = useEditor();
  const [envVars, dispatchEnv] = useEnvironmentVariables();
  const { setActiveTab, setVisibility } = useProjectSettingsContext();
  const addAlertNotification = useAddAlertNotification();
  const [haveSeenNotification, setHaveSeenNotification] =
    useScopedPersistedState("MISSING_ENV_VAR", false, id);

  useEffect(
    function getEnvVars() {
      if (allowedCapabilities.secrets) {
        dispatchEnv({ type: "GET_SECRETS" });
      }
    },
    [id, allowedCapabilities.secrets],
  );

  useEffect(
    function notifyMissingEnvVars() {
      if (
        allowedCapabilities.secrets &&
        !haveSeenNotification &&
        envVars.state === "IDLE" &&
        envVars.secrets &&
        Object.values(envVars.secrets).some((item) => item === "") // find empty values
      ) {
        addAlertNotification({
          message:
            "One of your environment variables is empty and needs to be set.",
          showDismiss: true,
          callback: () => {
            setHaveSeenNotification(true);
          },
          uniqueName: "missing-env-var",
          actions: [
            {
              text: "Open settings",
              onAction: () => {
                setVisibility(true);
                setActiveTab("env");
                setHaveSeenNotification(true);
              },
            },
          ],
        });
      }
    },
    [envVars, allowedCapabilities.secrets],
  );

  return null;
};
